import {Form, Input, Button} from 'antd';
import {SearchIcon, FilterIcon} from "@/theme/assets/icons";
import style from './../style.module.scss'

export const SearchFilter = ({name = 'search', display, setIsShow, isShow, smallFilterSelectCount, ...rest}) => {
    const form = Form.useFormInstance();

    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                <Input
                    placeholder="input search text"
                    prefix={(
                        <>
                            <SearchIcon
                                className={'input_icon'}
                                onClick={form.submit}
                            />
                        </>
                    )}
                    className={style.search_filter}
                    {...rest}
                />
            </Form.Item>
            {display &&
                <Button
                    style={{
                        // width: "36px",
                        background: "#3D3D3D",
                        height: "36px",
                        textAlign: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        borderRadius: "8px",
                        color: 'white'
                    }}
                    icon={<FilterIcon />}
                    onClick={() => setIsShow(!isShow)}
                >
                    {smallFilterSelectCount !== 0 &&
                        <>
                            ({smallFilterSelectCount})
                        </>}
                </Button>
            }
        </>
    );
}